import ActivityIcon from '@/components/icons/activity';
import FormTemplateIcon from '@/components/icons/form-template';
import WarningTriangleIcon from '@/components/icons/warning-triangle';
import { TopbarTab } from '@/components/topbar/topbar';
import { getWorkspaceRoute } from '@/utils/routes';

export function TopbarActions() {
  return (
    <div className="flex h-full items-center">
      <TopbarTab href={getWorkspaceRoute('/issues')} label="Issues" icon={<WarningTriangleIcon />} />
      <TopbarTab href={getWorkspaceRoute('/issues/repairs/activity')} label="Repair Activity" icon={<ActivityIcon />} />
      <TopbarTab href={getWorkspaceRoute('/issues/repairs/forms')} label="Repair Forms" icon={<FormTemplateIcon />} active />
    </div>
  );
}
